import {mapState} from "vuex";
import AlertModal from "../components/modal/AlertModal";

export default {

    components: {AlertModal},
    data() {
        return {
            selectClub: null,
            selectPlayer: null,

            nameKeyword: null,
            isSearch: false,

            identificationCheck: true,

            emptyClubAlertShow: false,
            emptyPlayerNameAlertShow: false,


        }
    }, computed: {
        ...mapState('participants', ['clubs', 'players']),
        ...mapState('me', ['me', 'orgs'])
    },
    methods: {
        searchPlayerFunc() {

            if (!this.selectClub) {
                this.emptyClubAlertShow = true
            } else if (!this.nameKeyword) {
                this.emptyPlayerNameAlertShow = true
            } else {
                const temp = {
                    tnmtId: this.$route.params.tnmtId,
                    clubId: this.selectClub.orgId,
                    playerNameKey: this.nameKeyword
                }
                const _this = this
                this.$store.dispatch('participants/getClubPlayerList', temp).then(res => {
                    _this.isSearch = true
                })
            }
        },
        getPlayer(player) {
            this.selectPlayer = player
            this.isSearch = false
            const temp = {
                orgId: this.selectClub.orgId,
                userId: player.playerId,
                type: 'P'
            }

            this.$emit('input', temp)
        },
        selectClubChangeFunc() {
            this.selectPlayer = null
            this.nameKeyword = null
            this.$emit('input', null)

            this.isSearch = false
        }
    }
}
